<!-- This card is only for uploading tool images, not other image content -->
<template>
  <v-card color="primary" class="ma-auto" outlined max-width="500" v-if="isReady">
    <v-card-title class="white--text"
      >All Set - See you soon!<v-spacer />
      <v-btn
        class="mx-2"
        text
        fab
        dark
        small
        @click.stop="showHelp()"
        v-if="!$vuetify.breakpoint.mdAndUp"
      >
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </v-card-title>

    <!-- BODY STARTS HERE -->
    <v-list class="py-0">
      <!-- Part 1.1 - Main Data: Kerberos -->
      <v-list-item class="py-2">
        <v-list-item-icon>
          <v-icon> mdi-information-outline</v-icon>
        </v-list-item-icon>
        {{ activeEvent.confirmation }}
      </v-list-item>
      <v-list-item> Your session: {{ getSessionTime }} </v-list-item>
      <v-list-item> Meeting location: {{ getSessionLocation }} </v-list-item>
    </v-list>
    <v-divider />
    <v-layout justify-center align-center class="blue-grey lighten-3">
      <v-flex shrink>
        <v-img
          :src="existingImageURL"
          :width="targetWidth"
          :height="targetHeight"
          :contain="true"
          class="blue-grey lighten-5"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                :size="30"
                :width="7"
                color="primary"
                class="mr-5"
                indeterminate
              ></v-progress-circular>
              Updating...
            </v-row>
          </template>
        </v-img>
      </v-flex>
    </v-layout>
    <v-divider />
    <v-list class="py-0">
      <v-list-item class="py-2">
        <v-btn color="primary" large class="mr-3" @click="goBack">
          <v-icon class="mr-2">mdi-arrow-left</v-icon> Back to signup
        </v-btn>
      </v-list-item>
    </v-list>
  </v-card>
  <v-card color="primary" class="ma-auto" outlined max-width="500" v-else>
    <v-card-title class="white--text"
      >Loading data<v-spacer />
      <v-btn
        class="mx-2"
        text
        fab
        dark
        small
        @click.stop="showHelp()"
        v-if="!$vuetify.breakpoint.mdAndUp"
      >
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
    </v-card-title>
    <v-list>
      <v-list-item>
        <v-progress-circular
          :size="40"
          :width="7"
          color="secondary"
          class="mr-5"
          indeterminate
        ></v-progress-circular>
        Please wait a second or two...
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import moment from "moment";
import HelpDialog from "@/support/helpMessage";

export default {
  data: () => ({
    eventname: "iap",
    targetWidth: 200,
    targetHeight: 200,
    isSaving: false,
    myImage: "",
    resultImage: "",
    submitCounter: 0,
  }),

  computed: {
    isReady() {
      return this.activeEvent.name !== undefined;
    },
    userdata() {
      return this.$store.getters.getUserdata;
    },
    username() {
      return this.userdata.username;
    },
    events() {
      return this.$store.getters.getEventList;
    },
    activeEvent() {
      if (this.events == undefined) return {};
      if (this.events[this.eventname] == undefined) return {};
      return this.events[this.eventname];
    },
    registeredSession() {
      if (this.userdata.events == undefined) return [];
      if (this.userdata.events[this.eventname] == undefined) return [];
      return this.userdata.events[this.eventname];
    },
    getUserSession() {
      var session = this.activeEvent.sessions;
      if (session == undefined) return {};
      return session.find((el) => this.registeredSession.includes(el.id));
    },

    getSessionTime() {
      var session = this.getUserSession;
      if (session == undefined) return "loading, please wait";
      return moment(session.start, "MM/DD/YYYY hh:mma").format(
        "ddd, MMM DD, YYYY @ hh:mma"
      );
    },
    getSessionLocation() {
      var session = this.getUserSession;
      if (session == undefined) return "loading, please wait";
      if (session.location == undefined) return "TBD";
      return session.location;
    },

    existingImageURL() {
      if (this.userdata.content == undefined) return undefined;
      if (this.userdata.content[this.eventname] == undefined) return undefined;
      return this.userdata.content[this.eventname] + "s" + this.submitCounter;
    },
  },

  methods: {
    async showHelp() {
      const aMessage = HelpDialog.GetHelpMessage();
      await this.$root.$confirmdialog("About - Fab.nano Signup", aMessage, {
        color: "secondary",
        reject: "",
        accept: "Okay",
      });
    },
    goBack() {
      this.submitCounter++;
      this.$router.push("/");
    },
  },

  mounted() {
    console.log("mounted summary");
  },
};
</script>
